import { handleError } from "@/utils/error";
import { useCreateFundBasket, useFetchFundBasketById } from "creso-core/hooks";
import { CopyIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { DropdownMenuItem } from "web-design-system";

export function DuplicateFundBasket(props: { id: number }) {
  const fetchFundBasket = useFetchFundBasketById();
  const { mutateAsync: createFundBasket } = useCreateFundBasket();
  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicateBasket = async () => {
    setIsDuplicating(true);
    try {
      const basket = await fetchFundBasket(props.id);
      await createFundBasket({
        name: `${basket.name} (Copy)`,
        tenure: basket.tenure,
        strategy: basket.strategy,
        description: basket.description,
        funds: basket.funds.map((fund) => ({
          fund_scheme: fund.fund_scheme_id,
          allocation_percentage: parseFloat(fund.allocation_percentage),
        })),
      });
      toast.success("Basket duplicated successfully.");
    } catch (error) {
      handleError(error, "Failed to duplicate fund basket");
    } finally {
      setIsDuplicating(false);
    }
  };

  return (
    <DropdownMenuItem disabled={isDuplicating} onSelect={handleDuplicateBasket}>
      <CopyIcon />
      Duplicate Basket
    </DropdownMenuItem>
  );
}
